import { ReactNode } from "react";
import { ThemeProvider } from "styled-components";
import { getTheme } from "./theme/themes";


interface ThemeProps {
    children: ReactNode;
}

/**
 * Theme Component that wraps an application and provides a theme based on the VITE_THEME environment variable.
 * The theme type uses the DefaultTheme type defined by styled-components and extends it using the custom interface 
 * ThemeProperties defined in src/theme/types.
 *
 * The defaultTheme is declared in styled.d.ts.
 * 
 * @example
 * // Usage:
 * <Theme>
 *     <YourComponent />
 * </Theme>
 *
 * // You can access theme properties in styled-components, if the component is wrapped in the Theme component:
 * const StyledDiv = styled.div`
 *     css-prop: ${props => props.theme.propertyName};
 * `;
 */
const Theme : React.FC<ThemeProps> = ({ children } ) => {

    const themeName = import.meta.env.VITE_THEME;
    if (!themeName) {
        throw new Error("VITE_THEME environment variable is not defined");
    }
    
    const theme = getTheme(themeName);

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
}

export default Theme;
